import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/services/user-service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit{
  resetPasswordForm!: FormGroup
  token!: string | null
  submitted = false
  pending = false
  success = false
  message = ''

  constructor(
    private formBuilder: FormBuilder, 
    private userService: UserService,
    private route: ActivatedRoute ) {
    this.resetPasswordForm = this.formBuilder.group({
      password: ['', Validators.required]
    })
  }

  ngOnInit() {
    this.route.queryParamMap.subscribe(params => {
      this.token = params.get('token')
    });
  }

  resetPassword() {
    this.submitted =  true
    if (this.resetPasswordForm.valid && this.token) {
      this.pending = true
      const password = this.resetPasswordForm.get('password')?.value
      this.userService.resetPassword(this.token, password).subscribe({
        next: (response) => {
          this.pending = false
          this.success = true
          this.message = 'Successfully Changed.'
        },
        error: (error) => {
          this.pending = false
          this.message = 'Lets try again'
        }
      })
    }
  }
}
